import styled from 'styled-components'
import { CommonButton } from 'components/Button/index'

export const ShowMoreButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex: 1;
  justify-content: center;
`

export const ShowMoreCommonButton = styled(CommonButton)`
  display: flex;
  text-transform: capitalize;
  background: transparent;
  font-weight: 900;
  height: 40px;
  min-width: 230px;
`
